<div class="container">
    <!-- 1 - Seleccionar Moneda -->
    <div class="card mb-3">
      <div class="card-header">
        <h4>
            1 - SELECCIONAR MONEDA
        </h4>
      </div>
      <div class="card-body">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="warehouse" class="form-label">Bodega</label>
                        <div class="input-group">
                            <span class="input-group-text info" tooltip="Bodegas">
                                <div class="superposition-parent">
                                    <i class="fa fa-warehouse"></i>
                                </div>
                            </span>
                            <app-input-autocomplete (changeStatus)="selectWarehouse($event.filterElement)"
                                (inputMethod)="searchWarehouse()" [allBorderRadius]="false" [filterElements]="warehouses"
                                [placeholder]="'Ingresa una bodega'" [custom]="true" [inputs]="filterWarehouse">
                                <ng-template #itemsTemplate let-filter>
                                    <!-- This is the content that will be projected -->
                                    <div items>
                                        <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                            {{filter.name}}</h5>
                                        <span class="text-muted" style="color: white !important;">{{filter.code}} -
                                            NIT:
                                            <ng-container *ngIf="filter.nit">
                                                <b>{{filter.nit}}</b>
                                            </ng-container>
                                            <ng-container *ngIf="!filter.nit">
                                                <span style="color: gray;">
                                                    <i class="fa fa-circle-info"></i>No cuenta con NIT
                                                </span>
                                            </ng-container>
                                        </span>
                                    </div>
                                </ng-template>
                            </app-input-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                      <label class="form-label">Moneda</label>
                      <div class="input-group">
                        <select class="form-control" [(ngModel)]="inputs.currency" (change)="onCurrencyChange()">
                          <option *ngFor="let curr of currency" [value]="curr">{{ curr }}</option>
                        </select>
                      </div>
                    </div>
                  
                    <div class="form-group mt-2" *ngIf="inputs.currency === 'Dolares ($)'">
                      <label class="form-label">Tasa de cambio</label>
                      <input class="form-control" type="number" [(ngModel)]="exchangeRate" min="0" step="0.01" placeholder="Ingrese la tasa de cambio">
                    </div>
                  </div>
            </div>
            <div class="card-body">
                <div class="col">
                    <div class="form-group">
                        <label for="client-input" class="form-label">Proveedor <a (click)="editAndSave(null,true)" *ngIf="!creating"><i
                          class="a-hover fa fa-plus"></i></a> </label>
                        <div class="input-group input-group-sm" style="margin-bottom: 1em;">
                            <app-input-autocomplete [ruleToDisabled]="clients.length == 0" [allBorderRadius]="true"
                                [inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un proveedor'"
                                [filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
                                (changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
                                <ng-template #itemsTemplate let-filter>
                                    <!-- This is the content that will be projected -->
                                    <div items>
                                        <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                            {{filter.name}}</h5>
                                        <span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
                                    </div>
                                </ng-template>
                            </app-input-autocomplete>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </div>
  
    <!-- 2 - Ingreso de documentos -->
    <div class="card mb-3">
        <div class="card-header">
            <h4>
                2 - INGRESO DE DOCUMENTOS PARA LIQUIDAR ANTICIPOS
            </h4>
        </div>
        <div class="card-body">
            <!-- Proveedor info -->
            <div class="row mb-3" *ngIf="clientSelected">
            <div class="col-md-2"><strong>Proveedor</strong></div>
            <div class="col-md-2">CÓDIGO: {{ clientSelected.code }}</div>
            <div class="col-md-5">NOMBRE: {{ clientSelected.name }}</div>
            <div class="col-md-3">NIT: {{ clientSelected.nit }}</div>
            </div>
  
            <!-- Categorías -->
            <div class="row mb-3" *ngIf="clientSelected">
                <div class="col">
                    <div class="form-group">
                        <label for="category-input" class="form-label">Categoria</label>
                        <div class="input-group input-group-sm" style="margin-bottom: 1em;">
                            <app-input-autocomplete [ruleToDisabled]="categories.length == 0" [allBorderRadius]="true"
                                [inputs]="category" [placeholder]="'Ingresa el nombre de una categoria'"
                                [filterElements]="category.filterElements" [typeElements]="'category'" (inputMethod)="writeCategory()"
                                (changeStatus)="selectCategory($event.filterElement,1)" [custom]="true">
                                <ng-template #itemsTemplate let-filter>
                                    <div items>
                                        <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                            {{filter.name}}</h5>
                                    </div>
                                </ng-template>
                            </app-input-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="col-md-1">
                    <label for="category-plus-input" class="form-label"> </label>
                    <button class="btn btn-primary" (click)="addCategory()">
                    <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
  
        <!-- Datos del documento -->
        <div class="row mb-3">
          <div class="col-md-3">
            <label>Fecha Documento</label>
            <input class="form-control" type="date" [(ngModel)]="document.date" />
          </div>
          <div class="col-md-3">
            <label>Mes de Ingreso</label>
            <input class="form-control" type="month" [(ngModel)]="document.month" />
          </div>
          <div class="col-md-3">
            <label>Tipo de documento:</label>
            <select class="form-control" [(ngModel)]="document.typeId">
              <option *ngFor="let type of documentTypes" [value]="type.id">{{ type.name }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label>Tipo de Gasto:</label>
            <select class="form-control" [(ngModel)]="document.expenseType">
                <option value="Producto">Producto</option>
                <option value="Servicio">Servicio</option>
              </select>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-3">
            <label>Serie del Documento</label>
            <input class="form-control" [(ngModel)]="document.series" placeholder="Serie del documento" />
          </div>
          <div class="col-md-3">
            <label>No. de Documento</label>
            <input class="form-control" [(ngModel)]="document.number" placeholder="Número de documento" />
          </div>
          <div class="col-md-3">
            <label>Total Documento</label>
            <input class="form-control" type="number" [(ngModel)]="document.total" (input)="updateTotals()" />
          </div>
          <div class="col-md-3">
            <label>Total Declarado</label>
            <input class="form-control" type="number" [(ngModel)]="document.declaredTotal" (input)="updateTotals()" />
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-12">
            <label>Descripción: {{ document.description.length }}/100</label>
            <input class="form-control" maxlength="100" [(ngModel)]="document.description" placeholder="Descripción" />
          </div>
        </div>
        <button *ngIf="!editDocument" class="btn btn-outline-primary" (click)="addDocument()">+ Agregar Documento</button>
        <button *ngIf="editDocument" class="btn btn-outline-primary" (click)="addDocument()">Editar documento</button>
      </div>
    </div>
  
    <!-- 3 - Documentos -->
    <div class="card mb-3">
        <div class="card-header">
            <h4>
                3 - DOCUMENTOS
            </h4>
        </div>
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Tipo de Documento</th>
              <th>Serie</th>
              <th>Numero</th>
              <th>Total</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of documents">
              <td>{{ doc.date }}</td>
              <td>{{ doc.type }}</td>
              <td>{{ doc.series }}</td>
              <td>{{ doc.number }}</td>
              <td>{{ doc.total | currency:'Q. ':'symbol':'1.2-2' }}</td>
              <td>
                <button class="btn btn-sm btn-danger" (click)="removeDocument(doc)">Eliminar</button>
                <button class="btn btn-sm btn-info" (click)="editDoc(doc)">Editar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  
    <!-- 4 - Totales -->
    <div class="card mb-3">
        <div class="card-header">
            <h4>
                4 - TOTALES
            </h4>
        </div>
        <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <label>Documentos Cargados</label>
                <p>{{ documents.length }}</p>
              </div>
              <div class="col-md-6">
                <label>Total registrado</label>
                <p>{{ totalRegistered | currency:'Q. ':'symbol':'1.2-2' }}</p>
              </div>
            </div>
            <div class="row mb-3">
                <!-- <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="batchSwitch" [(ngModel)]="useBatch">
                    <label class="form-check-label" for="batchSwitch">Registrar como lote</label>
                  </div> -->
                  
                  <div *ngIf="useBatch" class="mb-3">
                    <label for="batchName">Nombre del lote:</label>
                    <input type="text" id="batchName" class="form-control" [(ngModel)]="batchName" placeholder="Ingresa el nombre del lote">
                  </div>
                  
                  <button class="btn btn-outline-primary" (click)="registerDocuments()" *ngIf="loadingConfig && !checkAdministration">
                    {{ useBatch ? '+ Registrar Documentos como lote' : '+ Registrar Documento individual' }}
                  </button>
                  <br>
                  <button class="btn btn-outline-primary" (click)="registerDocumentsAdministrative()" *ngIf="loadingConfig && checkAdministration">
                    {{ useBatch ? '+ Registrar Documentos como lote' : '+ Registrar Documento individual Administrativa' }}
                  </button>
            </div>
        </div>
    </div>
    <div class="hide-background" *ngIf="isAddCategory">
      <div class="for-click" (click)="resetDeletingDiv()"></div>
      <div class="modal" tabindex="-1" *ngIf="isAddCategory">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1>Agregar categoria a proveedor</h1>
            </div>
            <div class="modal-body">
              <div class="col">
                    <div class="form-group">
                        <label for="category-all-input" class="form-label">Categoria</label>
                        <div class="input-group input-group-sm" style="margin-bottom: 1em;">
                            <app-input-autocomplete [ruleToDisabled]="allCategories.length == 0" [allBorderRadius]="true"
                                [inputs]="allCategory" [placeholder]="'Ingresa el nombre de una categoria'"
                                [filterElements]="allCategory.filterElements" [typeElements]="'allCategory'" (inputMethod)="writeAllCategory()"
                                (changeStatus)="selectAllCategory($event.filterElement,1)" [custom]="true">
                                <ng-template #itemsTemplate let-filter>
                                    <div items>
                                        <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                                            {{filter.name}}</h5>
                                    </div>
                                </ng-template>
                            </app-input-autocomplete>
                        </div>
                    </div>
                </div>
              <tfoot>
                <button class="btn btn-outline-primary" (click)="addCategoryToVendor()">
                  Agregar Categoria
                </button>
              </tfoot>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" (click)="isAddCategory = false">
                <i class="fa fa-xmark"></i>CERRAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<app-modal-vendor *ngIf="creating || editing" [newVendor]="newVendor" [isCreating]="creating" (close)="closeModalProvider()"></app-modal-vendor>
  